import { Box } from '@/components/box';
import { styled } from '@/stitches.config';
import { ArrowRight } from '@/components/icons';
import { AnimatePresence, motion } from 'framer-motion';

import { useExperienceStore } from '../../store';

interface CaseButtonProps {
  isInverted?: boolean;
}

export function CaseButton({ isInverted }: CaseButtonProps) {
  const { updateState } = useExperienceStore((state) => ({
    updateState: state.updateState,
  }));

  function onClickHandler() {
    updateState('outro');
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -30 }}
        transition={{ duration: 0.3 }}
      >
        <Button onClick={onClickHandler} isInverted={isInverted}>
          <Box
            as="span"
            css={{
              display: 'flex',
              gap: '$2',
              alignItems: 'center',
            }}
          >
            <span>Visit this case</span>
            <ArrowRight />
          </Box>
        </Button>
      </motion.div>
    </AnimatePresence>
  );
}

const Button = styled('button', {
  alignItems: 'center',
  display: 'inline-flex',
  userSelect: 'none',
  border: '1px solid currentColor',
  fontSize: '$3',
  padding: '$3 $4',
  position: 'relative',
  textDecoration: 'none',
  color: '$gray12',

  svg: {
    '@motion': {
      transition: 'transform 0.2s',
    },
  },
  '&:hover svg': {
    transform: 'translateX($space$1)',
  },

  variants: {
    isInverted: {
      true: {
        color: '$background',
        border: '1px solid $background',
      },
    },
  },
});
